import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import Partner from '../components/partners/partners_body';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Partners", "partner/partner_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Partners || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <Partner />
    </div>
  );
};

export default Page;